<template>
    <div style="padding-top: 25px">
        <div class="top-tips m-b-20">最后请完善您的账号信息</div>
        <div class="item">
            <div class="label">微信号</div>
            <div class="value">
                <div class="qr-tips">打开微信扫描验证码完成验证</div>
                <div class="qr">
                <wechartQR id="login_container" redirect-path="/register/step" :query="{
                    password,
                    repassword
                }"/>
                </div>
            </div>
        </div>
        <div class="item">
            <div class="label">设置登录密码</div>
            <div class="value">
                <div class="input-box">
                    <input type="password" @blur="pwdblur" @change="setStorage('reg_password', password)" v-model="password"  class="reg-inp" placeholder="请输入登录密码">
                </div>
            </div>
            <!-- <div class="reg-war hide">密码必须包括大小写、数字、且长度不得少于6位</div> -->
        </div>
        <div class="item">
            <div class="label">再次输入密码</div>
            <div class="value">
                <div class="input-box">
                    <input type="password" @blur="repwdblur" @change="setStorage('reg_repassword', repassword)" v-model="repassword" class="reg-inp" placeholder="再次输入密码">
                </div>
               
                <div class="error">{{pwderror || repwderror}}</div>
            </div>
        </div>
        <div class="item">
            <div class="label"></div>
            <label class="value flex">
                <input style="margin-right: 8px" type="checkbox" v-model="isagree">我已阅读并同意《在他乡服务协议》及《在他乡隐私声明》
            </label>
            <!-- <div class="steperror" style="margin-top:15px;">您必须同意注册协议</div> -->
        </div>
         <div class="item">
            <div class="label"></div>
            <div class="value">
                <div class="primary-btn" @click="hrReg">下一步</div>
            </div>
            <!-- <div class="steperror" style="margin-top:15px;">您必须同意注册协议</div> -->
        </div>
    </div>
</template>
<script>
import wechartQR from '../../components/wechartQR.vue'
const qs = require('qs');
export default {
    data() {
        return {
            phone: '',// 手机号码
            mobileYzm: '', // 手机验证码
            captcha: '', // 图片验证码
            captchasrc: '/wapi/base/captcha', //图片验证码地址
            isreg: false, // 是否已经注册 默认false 没有注册
            yzmtxt: '发送验证码',
            issend: false, // 是否发送验证码
            password: '',
            repassword: '',
            isagree: true, // 是否同意注册协议
            imgyzmerror: '',
            dxyzmerror: '',
            pwderror: '',
            repwderror: '',
            phoneerror: '',
            code: null
        }
    },
    components: {wechartQR},
    created(){
         this.password = sessionStorage.getItem('reg_password') || '';
         this.repassword = sessionStorage.getItem('reg_repassword') || '';
        const route = this.$route;
        this.code = route.query.code;
    },
    methods: {
        setStorage(key, value){
            sessionStorage.setItem(key, value)
        },
        hrLogin(){
            this.imgyzmblur();
            this.dxyzmblur();
            if (this.phoneerror  || this.imgyzmerror || this.dxyzmerror) {
                return;
            }
            let qdata = {
                phone:this.phone,
                verifyCode :this.mobileYzm
            };
            let url = `/wapi/hr/smsLogin`;
            this.axios.post(url,qs.stringify(qdata)).then(res => {
                if(res.success){
                    this.$router.push('/register/join')
                }
            })
        },
        // 图片验证码blur
        imgyzmblur() {
            if (this.captcha.length == 0) {
                this.imgyzmerror = '请输入图片验证码';
                // this.isvalia = false;
                return;
            } else if (this.captcha.length < 4) {
                this.imgyzmerror = '请输入4位图片验证码';
                //  this.isvalia = false;
                return;
            } else {
                // this.isvalia = true;
                this.imgyzmerror = '';
            }
        },
        dxyzmblur() {
            if (this.mobileYzm.length == 0) {
                this.dxyzmerror = '请输入短信验证码';
                return;
            } else if (this.mobileYzm.length != 6) {
                this.dxyzmerror = '请输入6位短信验证码';
                return;
            } else {
                this.dxyzmerror = '';
            }
        },
        pwdblur() {
            let pwd = this.password;
            if (pwd.length == 0) {
                this.pwderror = '请输入密码';
                return false;
            } else if (pwd.length < 6) {
                this.pwderror = '密码至少6位';
                return false;
            } else {
                this.pwderror = '';
            }
            return true
        },
        repwdblur() {
            let repwd = this.repassword;
            if (repwd.length == 0) {
                this.repwderror = '请再次输入您的密码';
                return false;
            } else if (repwd != this.password) {
                this.repwderror = '两次密码输入不一致';
                return false
            } else {
                this.repwderror = '';
            }
            return true
        },
        sendYzm() {
            this.yzisReg();
            this.imgyzmblur();
            if (this.phoneerror || this.imgyzmerror) {
                return;
            }
            let url = '/wapi/hr/getRegCode?phone=' + this.phone + '&captcha=' + this.captcha;
            if(this.isreg){
                url =  `/wapi/hr/getLoginCode?captcha=${this.captcha}&phone=${this.phone}`;
            }
            this.axios.get(url)
                .then(response => {
                    if (response.status * 1 == 200) {
                        this.issend = true;
                        this.yzmDjs();
                    }else{
                        this.captchaChange();
                    }
                })
        },
        yzmDjs() {
            let times = 60;
            this.yzmtxt = times + 's后重新发送';
            let interval = setInterval(() => {
                times--;
                if (times < 0) {
                    clearInterval(interval);
                    this.yzmtxt = "发送验证码"
                    this.issend = false;
                } else {
                    this.yzmtxt = times + 's后重新发送';
                }
            }, 1000);
        },
        //验证是否可以注册
        yzisReg() {
            if (this.phone == '') {
                this.phoneerror = '请输入手机号'
            } else if (!(/^1[34578]\d{9}$/.test(this.phone))) {
                this.phoneerror = '手机号码格式有误'
            } else {
                this.axios.get('/wapi/hr/isReg?phone=' + this.phone)
                    .then(res => {
                        if (res.data.isReg == 1) {
                            this.phoneerror = ''
                            this.isreg = true;
                        } else {
                            this.isreg = false;
                            this.phoneerror = '';
                        }
                    }).catch(error => {
                    throw new Error(error);
                })
            }

        },
        // 图形验证码点击改变
        captchaChange() {
            let times = (new Date()).getTime();
            this.captchasrc += '?times=' + times;
        },
        hrReg() {
            if (!this.pwdblur() || !this.repwdblur()) {
                return;
            }
            if (!this.isagree) {
                this.$message('您必须同意注册协议');
                return;
            }
            let qdata = {
                password: this.password,
                passwordAgain: this.repassword,
                code: this.code
            }
            this.axios.get('/wapi/hr/modifyAndBind?'+ qs.stringify(qdata))
                .then((res) => {
                    if (res.status * 1 == 200 || res.status == 101) {
                        this.$router.push({path: '/register/join'})
                    }

                })
        }
    }
}
</script>
<style scoped lang="less">
@import url('../../assets/less/reglogin.less');
.top-tips{
    width: 520px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #F4F9FF;
    border-radius: 4px;
    border: 1px solid #057CF9;
    color: #42464B;
    font-size: 16px;
}
@value-main-width: 220px;
.qr-tips{
    line-height: 40px;
    width: @value-main-width;
    text-align: center;
}
.qr{
    width: @value-main-width;
    height: @value-main-width;
}
.input-box{
    width: @value-main-width;
}
</style>



// WEBPACK FOOTER //
// stepone.vue?11ba7e53